import { NgModule, SkipSelf, Optional } from '@angular/core';
import { PermissionResourceService } from "./permissionResource.service";
import { ApiResourceModule } from '../../apiResource/apiResource.module';
import { UserAuthModule } from 'libraries/service/user-auth/user-auth.module';
import { ConfigurationResourceModule } from "libraries/service/resources/configuration/configurationResource.module";

@NgModule({
    imports: [
        ApiResourceModule,
        UserAuthModule,
        ConfigurationResourceModule,
    ],
    providers: [
        PermissionResourceService,
    ]
})
export class PermissionResourceModule {
    constructor(@Optional() @SkipSelf() parentModule: PermissionResourceModule) {
        if (parentModule) {
            throw new Error(
                'PermissionResourceModule must not be imported directly, because it is only created once and imported from the root module.');
        }
    }
}
